import fr_Fr from "./fr_Fr.json"
export const languageData = {
    fr:fr_Fr
}